<template>
  <div>
    <a-button style="margin-bottom: 10px" type="primary" @click="fetch()">刷新列表 <a-icon type="retweet" /></a-button>
    <div>
      <label title="供应商" class="info">供应商</label><a-input style="max-width: 10%; margin-right: 20px" placeholder="客户名" v-model="provider_name"/>
      <label title="备注" class="info">备注</label><a-input style="max-width: 10%; margin-right: 20px" placeholder="客户名" v-model="remark"/>
      <a-button type="primary" @click="newProvider">新增</a-button>
    </div>
    <a-table :columns="columns"
             :dataSource="data"
             :loading="loading"
             :pagination="false"
             class="general-table"
             style="font-size: 12px !important; margin-top: 10px"
    >
      <!--<div slot="permission_list" slot-scope="text, record">-->
      <!--<a-checkbox-group :options="permissionList" v-model="record.permission_list" @change="onChange(record)" >-->
      <!--&lt;!&ndash;<span style="color: red" slot="label" slot-scope="{value}">{{value}}</span>&ndash;&gt;-->
      <!--</a-checkbox-group>-->
      <!--</div>-->
    </a-table>
  </div>
</template>

<script>
const axios = require('axios')
export default {
  name: 'ProviderManage',
  data () {
    return {
      loading: false,
      provider_name: '',
      remark: '',
      data: [],
      columns: [{
        title: '供应商',
        dataIndex: 'provider_name'
      }, {
        title: '备注',
        dataIndex: 'remark'
      }]
    }
  },
  created () {
    this.fetch()
  },
  computed: {
    getProviderListUrl: function () {
      return global.DOMAIN + global.API_VERSION + 'uprovider/get_provider_list'
    },
    newProviderUrl: function () {
      return global.DOMAIN + global.API_VERSION + 'uprovider/new_provider'
    }
  },
  methods: {
    fetch () {
      this.loading = true
      axios.post(this.getProviderListUrl, {
        token: sessionStorage.token
      })
        .then((data) => {
          if (data.data.err_code === 0) {
            this.data = data.data.content.provider_list
            this.loading = false
          } else if (data.data.err_code === 50002) {
            console.log('token 不对，跳转登录')
            this.$router.push('/')
          }
        })
    },
    newProvider () {
      axios.post(this.newProviderUrl, {
        provider_name: this.provider_name,
        remark: this.remark,
        token: sessionStorage.token
      })
        .then((data) => {
          if (data.data.err_code === 0) {
            this.data.unshift(data.data.content.provider)
            // console.log('dataList', dataList)
            this.provider_name = ''
            this.remark = ''
          } else if (data.data.err_code === 50002) {
            console.log('token 不对，跳转登录')
            this.$router.push('/')
          }
        })
    }
  }
}
</script>

<style scoped>

</style>
